/* eslint-disable react/prop-types */ // TODO: add props
import { useEffect } from 'react';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { STATUS } from 'edrolo/domains/bySchoolClass';
import style from './PrevNextLinks.scss';

const EnabledLink = ({ to, children, onClick }) => (
  <Link to={to} className={cx(style.text, style.link)} onClick={onClick}>
    {children}
  </Link>
);
const DisabledLink = ({ children }) => (
  <span className={style.text}>{children}</span>
);
const Seperator = () => (
  <div className={style.seperatorContainer}>
    <div className={style.seperator} />
  </div>
);

const PrevNextLinks = ({
  classId,
  assemblageStatus,
  loadAssemblage,
  prevQuestionSetId,
  nextQuestionSetId,
  buildUrl,
  analyticsPayload,
}) => {
  useEffect(() => {
    if (assemblageStatus === STATUS.UNINITIALIZED) {
      loadAssemblage(classId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- FIXME
  }, [classId]);

  return (
    <div className={style.container}>
      {prevQuestionSetId ? (
        <EnabledLink
          to={buildUrl(prevQuestionSetId)}
          onClick={() =>
            global.analytics.track(
              'clicked question set results grid previous question set link',
              { ...analyticsPayload, prevQuestionSetId }
            )
          }
        >
          « Prev
        </EnabledLink>
      ) : (
        <DisabledLink>« Prev</DisabledLink>
      )}
      <Seperator />
      {nextQuestionSetId ? (
        <EnabledLink
          to={buildUrl(nextQuestionSetId)}
          onClick={() =>
            global.analytics.track(
              'clicked question set results grid next question set link',
              { ...analyticsPayload, nextQuestionSetId }
            )
          }
        >
          Next »
        </EnabledLink>
      ) : (
        <DisabledLink>Next »</DisabledLink>
      )}
    </div>
  );
};

export default PrevNextLinks;
